import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'critical' | 'accent';

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-surface-2 text-ink-2',
  info: 'bg-info-bg text-info',
  success: 'bg-ok-bg text-ok',
  warning: 'bg-warn-bg text-warn',
  critical: 'bg-crit-bg text-crit',
  accent: 'bg-accent-soft text-accent',
};

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  /** A small dot before the label — useful in dense tables. */
  withDot?: boolean;
  className?: string;
}

/**
 * Status label. Every status in the product is rendered through this, so
 * "Suspended" looks identical on the institutes table, the detail header and the
 * dashboard.
 */
export function Badge({ tone = 'neutral', children, withDot = false, className }: BadgeProps) {
  return (
    <span className={cn('pill  text-[12px] tracking-label', TONE[tone], className)}>
      {withDot && <span className="h-1.5 w-1.5 rounded-pill bg-current" aria-hidden />}
      {children}
    </span>
  );
}
